<template>
    <div id="app">
        <div id="nav">
            <router-link to="/">Home</router-link>
            |
            <router-link to="/bingo">Bingo</router-link>
        </div>
        <router-view/>
    </div>
</template>

<script>
    /* eslint-disable no-console */

    import firebase from 'firebase'
    import authConfig from './config/firebaseConfig'

    export default {
        name: "App",
        mounted: function () {
            firebase.initializeApp(authConfig)
            firebase.database().ref('/bingo').on('value', snapshot => {
                if (snapshot.val() !== null) {
                    this.$store.state.bingoNum = snapshot.val()
                } else {
                    this.$store.state.bingoNum = snapshot.val()
                }
            })
            firebase.database().ref('/info/important').on('value', snapshot => {
                this.$store.state.important = snapshot.val()
            })
            firebase.database().ref('/info/infos').on('value', snapshot => {
                this.$store.state.infos = snapshot.val()
            })
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }
</style>
